import { useDispatch } from 'react-redux';
import { setGuestSignupModalVisible } from 'redux/mode/actions';
import * as S from './styles';

const GuestSignupModal = () => {
	const dispatch = useDispatch();

	const handleClose = () => {
		dispatch(setGuestSignupModalVisible(false));
	};

	const handleEmailClick = () => {
		window.open('mailto:hello@moonchild.ai?subject=Request for Invite Code', '_blank');
	};

	const handleWaitlistClick = () => {
		window.open('https://studio.moonchild.ai', '_blank');
	};

	const handleOutsideClick = (e: { preventDefault: () => void }) => {
		e.preventDefault();
		dispatch(setGuestSignupModalVisible(false));
	};

	return (
		<S.ModalOverlay onClick={handleOutsideClick}>
			<S.ModalContent onClick={(e: React.MouseEvent) => e.stopPropagation()}>
				<S.CloseButton onClick={handleClose}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path
							d="M12 4L4 12M4 4L12 12"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</S.CloseButton>

				<S.Content>
					<S.LeftColumn>
						<S.Headline>Ready to create something amazing?</S.Headline>
						<S.Body>
							You're currently in guest mode. Join our community of creators and start building your
							next project with full access to all features.
						</S.Body>
						<S.ButtonContainer>
							<S.PrimaryButton onClick={handleWaitlistClick}>Join Waitlist</S.PrimaryButton>
							<S.SecondaryButton onClick={handleEmailClick}>Request Invite Code</S.SecondaryButton>
						</S.ButtonContainer>
						<S.FooterText>
							Need immediate access? Email us at{' '}
							<S.EmailLink href="mailto:hello@moonchild.ai">hello@moonchild.ai</S.EmailLink> and
							tell us why. We read every message.
						</S.FooterText>
					</S.LeftColumn>
					<S.RightColumn>
						<img
							src="/images/skating-cat.png"
							alt="An illustrated cat riding a skateboard with a moon in the background"
						/>
					</S.RightColumn>
				</S.Content>
			</S.ModalContent>
		</S.ModalOverlay>
	);
};

export default GuestSignupModal;
